<rk-mobile-right-page-wrapper (cancelled)="hide()">
  @if (program$ | async; as program) {
    <rk-program-details-header
      class="block px-4 py-5"
      [program]="program"
    ></rk-program-details-header>
    @if (program.playlistsNumber > 0) {
      <rk-program-details-list [program]="program"></rk-program-details-list>
      <rk-mobile-fab-button (click)="addPlaylist()"></rk-mobile-fab-button>
    } @else {
      <div class="program-empty">
        <img src="/assets/playlist-empty.svg" />
        <div translate>SCHEDULE.PROGRAMS.PROGRAM_EMPTY</div>
        <rk-button
          (click)="addPlaylist()"
          [label]="'MEDIA.CONTEXT_MENU.ADD_PROGRAM_PLAYLIST' | translate"
        ></rk-button>
      </div>
    }
  } @else {
    <div>
      <rk-loader [isLoading]="true" [size]="60" [center]="true"></rk-loader>
    </div>
  }
</rk-mobile-right-page-wrapper>
